export default __webpack_public_path__ + "static/media/nip.ad9f590c.jpg";